export const positionStatus = {
    0: 0,
    1: 1,
    2: 1,
    3: 1,
    4: 2,
    5: 3,
    6: 4,
    7: 5,
    8: 5,
    9: 6
}

export const statuses = {
    0: "Mission created without selecting Delegate",
    1: "Mission created, Delegate chosen",
    2: "Mission created, Delegate chosen",
    3: "Mission created, Delegate chosen",
    4: "Delegate start mission",
    5: "Client Acknowledged",
    6: "Mission completed by Delegate",
    7: "Client confirms mission completed successfully",
    8: "Client confirms mission is not completed",
    9: "Mission is in archive"
}

export const statusList = ["Mission created without selecting Delegate", "Mission created, Delegate chosen",
    "Delegate start mission", "Client Acknowledged", "Mission completed by Delegate", "Client confirms mission completed successfully", "Mission is in archive"];
